
import { Cylinder, Sphere, useScroll} from '@react-three/drei'
import { Suspense, useRef, useState } from 'react'
import { useFrame } from '@react-three/fiber'
import { animated} from '@react-spring/three'
import Handwave from './Handwave'
import GamifyTheWorld from './GamifyTheWorld'
import { Kuma } from './Kuma'
import WorkStuff from './WorkStuff'
import ArtStuff from './ArtStuff'
import IntroText from './IntroText'
import CharacterGlasses from './CharacterGlasses'

export default function Me(props)
{
    const head = useRef();
    const body = useRef();     

    const scrollData = useScroll();
    const [isVisible, setIsVisible] = useState(false)
    const [showGlasses, setShowGlasses] = useState(false)
    const [glassesRotation, setGlassesRotation] = useState([0, 0, 0])
    const [activeFormField, setActiveFormField] = useState(null)
    const [whatsVisible, setWhatsVisible] = useState(
        {
            meFrom: 13, meTo: 170,
            rackethandFrom: 13, rackethandTo: 18,
            handwaveFrom: 18, handwaveTo: 24,
            gamifytheworldFrom: 24, gamifytheworldTo: 36,
            workstuffFrom: 36, workstuffTo: 55,
            hologramFrom: 42, hologramTo: 63,
            kumaFrom: 55, kumaTo: 74,
            bookFrom: 55, bookTo: 74,
            artstuffFrom: 72, artstuffTo: 92
        }
    )

    useFrame ((state, delta) =>
    {
        const scrollPercent = scrollData.range(0,1) * 100
        setIsVisible(scrollPercent > whatsVisible.meFrom && scrollPercent < whatsVisible.meTo)
        
        // Show glasses when contact form is visible (scroll point 150)
        setShowGlasses(scrollPercent > 95)
        
        // Calculate glasses rotation based on active form field
        if (activeFormField && showGlasses) {
            let targetRotation = [0, 0, 0];
            
            switch (activeFormField) {
                case 'name':
                    // Look slightly down and to the left (name field position)
                    targetRotation = [1.0, -1.1, -1.2];
                    break;
                case 'email':
                    // Look down and to the left (email field position)
                    targetRotation = [1.2, -0.9, -1.3];
                    break;
                case 'message':
                    // Look down and to the left (message field position)
                    targetRotation = [1.3, -0.5, -1.3];
                    break;
                default:
                    // Default position - looking straight ahead
                    targetRotation = [0.5, -0.6, 0]; // You can change this default rotation
            }
            
            // Smoothly interpolate to target rotation
            setGlassesRotation(prev => [
                prev[0] + (targetRotation[0] - prev[0]) * 0.1,
                prev[1] + (targetRotation[1] - prev[1]) * 0.1,
                prev[2] + (targetRotation[2] - prev[2]) * 0.1
            ]);
        } else {
            // Reset to default position when no field is active
            setGlassesRotation(prev => [
                prev[0] + (0.1 - prev[0]) * 0.1, // Change this to your desired default X rotation
                prev[1] + (-0.5 - prev[1]) * 0.1, // Change this to your desired default Y rotation
                prev[2] + (-0.3 - prev[2]) * 0.1  // Change this to your desired default Z rotation
            ]);
        }
    })

    return <>
        
        <group visible = {isVisible} position-x = {3.5} position-y = {28} position-z = {38} rotation-x={0.2}>

            {/* HEAD */}
            <animated.group ref = {head} position-x = {0.2}>
                <Sphere args = {[0.55, 32, 16]} position = {[-0.7, 3.2, 5]} rotation-y={Math.PI}>
                    <meshToonMaterial  color = "orange" />
                </Sphere>
                
                {/* Character Glasses */}
                <CharacterGlasses 
                    visible={showGlasses}
                    scale={0.15}
                    position={[-0.7, 3.2, 5.6]}
                    rotation={[glassesRotation[0], Math.PI + glassesRotation[1], glassesRotation[2]]}
                />
            </animated.group>

            {/* BODY */}
            <group ref = {body} position = {[0, 0, 5]} rotation = {[0, Math.PI, -0.2]}>
                <Sphere castShadow={true} args = {[0.7, 32, 16]} position = {[0, 1.7, 0]}>
                    <meshToonMaterial  color = {0x004e8b}/>
                </Sphere>

                <Cylinder castShadow={true} args = {[0.7, 0.8, 1.4, 16]} position = {[0,1,0]} rotation-y={Math.PI}>
                    <meshToonMaterial  color = {0x004e8b}/>
                </Cylinder>

                <Cylinder castShadow={true} args = {[0.7, 0.7, 0.6, 16]} position = {[0,0,0]} rotation-y={Math.PI}>
                    <meshToonMaterial  color = "orange" />
                </Cylinder>
                
                <Suspense><Handwave whatsVisible = {whatsVisible}/></Suspense>
                <Suspense><GamifyTheWorld whatsVisible = {whatsVisible} /></Suspense>
                <Suspense><WorkStuff whatsVisible = {whatsVisible} darkMode={props.darkMode}/></Suspense>
                <Suspense><Kuma scale={0.2} whatsVisible = {whatsVisible}></Kuma></Suspense>
                <Suspense><ArtStuff scale = {4} whatsVisible = {whatsVisible}></ArtStuff></Suspense>
                
            </group>
        </group>
        <IntroText darkMode = {props.darkMode} onActiveFieldChange={setActiveFormField}/> 
    </>       
}